import { UndoPartial } from '../@types'

export function removeEmptyFields<T>(obj: T): UndoPartial<T> {
  return Object.fromEntries(
    Object.entries(obj as { [s: string]: unknown }).filter(
      ([, v]) => v !== null && v !== undefined,
    ),
  ) as UndoPartial<T>
}
